import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';
import Loading from '../views/ui-components/Loading';

export const isAdminUser = (keycloak) => {
  const roles = keycloak.tokenParsed?.realm_access?.roles || [];
  return roles.includes('ADMIN');
};

const AdminRoute = ({ children }) => {
  const { keycloak, initialized } = useKeycloak();
  const navigate = useNavigate();
  const isAdmin = isAdminUser(keycloak);

  useEffect(() => {
    if (!initialized) {
      return;
    }
    if (!isAdmin) {
      navigate('/authentication/access-denied', { replace: true });
    }
  }, [initialized, isAdmin, navigate]);

  if (!initialized) {
    return <Loading />;
  }

  if (!isAdmin) {
    return null;
  }

  return children;
};

export default AdminRoute;
